import { NOTIFICATION_BROADCAST_TYPE } from "@/entities/notification-broadcast";
import { useEventBusListener } from "@/modules/event-bus";

import { useInterventionActionAssign } from "./intervention-action-assign.hook";

export const InterventionActionAssign = () => {
  const { runAction } = useInterventionActionAssign();

  useEventBusListener(
    NOTIFICATION_BROADCAST_TYPE.INTERVENTION_ASSIGN,
    runAction
  );

  return <></>;
};
